import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ExternalLink } from "@/components/UI/ExternalLink";
import {
  FOOTER_NAV_ITEMS,
  FOOTER_NAV_LABEL_KEY,
} from "@/components/Layout/footer/footerData";
import type { FooterNavigationItem } from "@/components/Layout/footer/footerData";
import { resolveHref } from "@/constants/navigation";
import { useLanguage } from "@/hooks/useLanguage";
import "./FooterNavigation.css";

function FooterNavigationLink({ item }: { item: FooterNavigationItem }) {
  const { t } = useTranslation();
  const { lang } = useLanguage();

  if (item.type === "internal") {
    return (
      <li className="site-footer__link-item">
        <Link to={item.to} reloadDocument={item.to.includes("#")}>{t(item.labelKey)}</Link>
      </li>
    );
  }

  return (
    <li className="site-footer__link-item">
      <ExternalLink href={resolveHref(item.href, lang)}>
        {t(item.labelKey)}
      </ExternalLink>
    </li>
  );
}

export function FooterNavigation() {
  const { t } = useTranslation();

  return (
    <nav className="site-footer__links" aria-label={t(FOOTER_NAV_LABEL_KEY)}>
      <ul className="site-footer__link-list">
        {FOOTER_NAV_ITEMS.map((item) => (
          <FooterNavigationLink key={item.id} item={item} />
        ))}
      </ul>
    </nav>
  );
}
